import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { UserRound, FileText, Store, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { Page } from "@/components/Page";

function Stat({ label, value, hint }) {
  return (
    <div className="stat" data-testid={`stat-${label.toLowerCase().replaceAll(" ", "-")}`}>
      <span>{label}</span>
      <strong>{value}</strong>
      <small>{hint}</small>
    </div>
  );
}
function ActionCard({ icon, title, text, link, to, done }) {
  return (
    <NavLink to={to} className="action-card" data-testid={`action-${title.toLowerCase().replaceAll(" ", "-")}`}>
      <div className="action-icon">{icon}</div>
      <div>
        <h4>{title}{done && <span className="check">✓</span>}</h4>
        <p>{text}</p>
        <span className="arrow-link">{link} <ArrowUpRight size={15}/></span>
      </div>
    </NavLink>
  );
}

export default function Overview({ user }) {
  const [data, setData] = useState({ stats: {}, profile: null, products: [], submissions: [] });
  useEffect(() => { api.get("/dashboard").then(r => setData(r.data)).catch(() => {}); }, []);

  return (
    <Page title={`Good day, ${user.name.split(" ")[0]}.`} subtitle="Your GI journey, seller presence, and next steps — all in one place.">
      <section className="welcome-band">
        <div>
          <p className="eyebrow light">YOUR AUTHORISED USER JOURNEY</p>
          <h2>Make your origin<br/><em>matter.</em></h2>
          <p>Build trust around the work you make and the place it comes from.</p>
        </div>
        <div className="welcome-symbol">✦</div>
      </section>

      <div className="stats">
        <Stat label="GI profile" value={data.profile ? "Ready" : "Start"} hint={data.profile ? "Profile is published" : "Tell your story"}/>
        <Stat label="Products listed" value={data.stats.products || 0} hint="In the marketplace"/>
        <Stat label="Applications" value={data.stats.submissions || 0} hint="Track progress"/>
        <Stat label="Buyer requests" value={data.stats.quotes || 0} hint="Awaiting your reply"/>
      </div>

      <div className="section-head">
        <div>
          <p className="eyebrow">YOUR NEXT STEPS</p>
          <h3>A clearer path forward</h3>
        </div>
        <span className="status-pill"><span/> Workspace active</span>
      </div>

      <div className="action-grid">
        <ActionCard icon={<UserRound/>} title="Complete your GI profile" text="Share the story, credentials, and product behind your application." link="Open profile" to="/profile" done={!!data.profile}/>
        <ActionCard icon={<FileText/>} title="Start an application" text="Prepare your submission and send the signed originals to our team." link="View applications" to="/documents"/>
        <ActionCard icon={<Store/>} title="List your first product" text="Reach buyers looking for authentic, traceable GI products." link="Open marketplace" to="/marketplace"/>
      </div>
    </Page>
  );
}
